module.exports = __webpack_public_path__ + "static/media/redeemIcon.7d873a94.svg";